var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShoppingBasket(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "rgba(21,27,38,.75)",
    viewBox: "0 0 24 24",
    title: "shopping_basket",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "MultiColorIcon-path--fadedBlack",
    d: "M15.8,1.1c-0.4,0.2-0.5,0.6-0.3,1L19.1,9H4.9l3.7-6.9c0.2-0.4,0.1-0.8-0.3-1C7.9,0.9,7.4,1,7.2,1.4L3.2,9 c0,0,0,0,0,0H1.5C0.7,9,0,9.7,0,10.5C0,11.3,0.7,12,1.5,12h21c0.8,0,1.5-0.7,1.5-1.5C24,9.7,23.3,9,22.5,9h-1.7c0,0,0,0,0,0l-4-7.5 C16.6,1,16.1,0.9,15.8,1.1z M7,14c-0.6,0-1,0.4-1,1v5c0,0.6,0.4,1,1,1s1-0.4,1-1v-5C8,14.4,7.6,14,7,14z M11,15c0-0.6,0.4-1,1-1 s1,0.4,1,1v5c0,0.6-0.4,1-1,1s-1-0.4-1-1V15z M17,14c-0.6,0-1,0.4-1,1v5c0,0.6,0.4,1,1,1s1-0.4,1-1v-5C18,14.4,17.6,14,17,14z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    className: "MultiColorIcon-path--white",
    d: "M3.8,20.4L2,12h20l-1.8,8.4c-0.2,0.7-0.6,1.4-1.1,1.9s-1.3,0.7-2,0.7H6.9c-0.7,0-1.4-0.3-2-0.7 C4.3,21.8,3.9,21.1,3.8,20.4z M7,14c-0.6,0-1,0.4-1,1v5c0,0.6,0.4,1,1,1s1-0.4,1-1v-5C8,14.4,7.6,14,7,14z M11,15c0-0.6,0.4-1,1-1 s1,0.4,1,1v5c0,0.6-0.4,1-1,1s-1-0.4-1-1V15z M17,14c-0.6,0-1,0.4-1,1v5c0,0.6,0.4,1,1,1s1-0.4,1-1v-5C18,14.4,17.6,14,17,14z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingBasket);
export default __webpack_public_path__ + "static/media/shopping_basket.4162b20a.svg";
export { ForwardRef as ReactComponent };